import React, { FC } from 'react'
import { ResourceRowContainer } from './style'

//* components
import ResourceRow from '../../global/resourceRow'
import Typography from '../../global/typography'

//* utils
import { LocaleCodes } from '../../../constants/localization.constants'
import formatInlineCode from '../../../utils/shortTextFormatting'
import { getDynamicContent } from './util/helper'

type Props = {
  relatedResources: {
    slug?: string
    teaserBody?: string
    __typename?: string
    seoMetadata?: any
    spotlights?: any
    hero?: any
  }[]
  featuredResource?: any
  resourceRowIntro: string
  location: any
  locale?: string
}

const DynamicRow: FC<Props> = ({
  relatedResources,
  featuredResource,
  resourceRowIntro,
  location,
  locale,
}) => {
  if (!relatedResources || relatedResources.length === 0) return null
  const dynamicContent = getDynamicContent(relatedResources, featuredResource, location)

  const dynamicRowData = {
    featuredPages: dynamicContent,
    bottomPadding: 'Small',
    topPadding: 'Small',
  }

  return (
    <ResourceRowContainer data-cy={`RelatedResourceDynamicRow`}>
      <Typography className="ResourseRow_Intro" type="header2">
        {formatInlineCode(resourceRowIntro || '')}
      </Typography>
      {/* @ts-ignore */}
      <ResourceRow data={dynamicRowData} locale={locale || LocaleCodes.ENGLISH.code}></ResourceRow>
    </ResourceRowContainer>
  )
}

export default DynamicRow
